export default "__VITE_ASSET__BVMu0l9r__"